export const RecommendationsMatchType = {
    Investor: 'INVESTOR',
    Startup: 'COMPANY',
    Both: 'BOTH',
};
